import RefreshButton from '@/components/RefreshButton';
import { Button, Input, Select, Space } from 'antd';

import { ChevronDownIcon, SearchIcon, UploadIcon } from '@/icons';
import { useEffect } from 'react';
import type { ShiftAssignParams } from '../../../../../../app/features/employee/emp-attendance/emp-attendance.type';
import { useGetAllDepartmentsQuery } from '../../../../../../app/features/employee/emp-dashboard/emp-dashboard.api';
import useDebounce from '../../../../../../hooks/useDebounce';
import useDiscloser from '../../../../../../hooks/useDiscloser';
import { useQueryFilters } from '../../../../../../hooks/useQueryFilters';
import AssignShift from './AssignShift';
import ShiftAssignImport from './ShiftAssignImport';
import ImportShift from './ImportShift';

export default function ShiftAndRoasterFilter() {
  const [open, handleOpen, handleClose] = useDiscloser<
    'IMPORT_SHIFT_ASSIGN' | 'IMPORT_SHIFT' | 'ADD' | 'UPDATE'
  >();
  const { keyword, handleInputChange } = useDebounce();
  const { filters, setFilterValue } = useQueryFilters<ShiftAssignParams>();
  const { data: departmentsData } = useGetAllDepartmentsQuery({
    params: { page: 1, limit: 100, status: 'active' },
  });

  useEffect(() => {
    setFilterValue('search', keyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  return (
    <>
      <div className="flex flex-col gap-3 items-end">
        <Space className="filter-section" wrap>
          <Input
            size="large"
            prefix={<SearchIcon size={20} className="px-1" />}
            placeholder="Search Employee ID/Name"
            className="w-72"
            onChange={handleInputChange}
            allowClear
          />
          <Select
            size="large"
            className="min-w-36"
            placeholder="Department"
            suffixIcon={<ChevronDownIcon size={24} />}
            popupMatchSelectWidth={200}
            value={filters.departmentId}
            onChange={(value) => setFilterValue('departmentId', value)}
            options={
              departmentsData?.data?.data?.map((department) => ({
                value: department.id,
                label: department.name,
              })) || []
            }
            allowClear
          />
        </Space>
        <Space className="filter-section" wrap>
          <RefreshButton
            endpoints={[
              'getAllShifts',
              'getTenantUsersWithShiftAssignments',
              'getShiftDetails',
              'getFailedShiftsJobs',
              'getFailedShiftAssignJobs',
            ]}
          />
          <Button
            size="large"
            className="btn-primary-bordered"
            onClick={() => handleOpen({ type: 'IMPORT_SHIFT_ASSIGN' })}
          >
            Import Schedule
            <UploadIcon />
          </Button>
          <Button
            size="large"
            className="btn-primary-bordered"
            onClick={() => handleOpen({ type: 'IMPORT_SHIFT' })}
          >
            Import Shift
            <UploadIcon />
          </Button>
          <Button
            size="large"
            className="btn-primary"
            onClick={() => handleOpen({ type: 'ADD' })}
          >
            Add Shift & Assign
          </Button>
        </Space>
      </div>

      <ShiftAssignImport
        handleClose={handleClose}
        open={open.open && open.type === 'IMPORT_SHIFT_ASSIGN'}
      />
      <ImportShift
        handleClose={handleClose}
        open={open.open && open.type === 'IMPORT_SHIFT'}
      />
      <AssignShift
        data={open.data}
        type={open.type}
        handleClose={handleClose}
        open={open.open && open.type === 'ADD'}
      />
    </>
  );
}
